/**
 * cmRegistry — the live CodeMirror views currently mounted.
 *
 * WHY (Walter 2026-08-23). Ctrl+F was dead in the live-preview editor:
 * `FindBar` collects matches by querying `textarea[data-find-target]`, and
 * CodeMirror isn't a textarea, so every search returned `0/0`. It had been
 * broken for anyone on the beta editor since it shipped, which by now is both
 * of his devices.
 *
 * Searching the rendered DOM instead wouldn't do: CodeMirror HIDES the syntax
 * markers, so the text on screen and the text in the document have different
 * offsets, and a match found in the rendering can't be mapped back to a
 * position to scroll to. The document is the only sound thing to search, so
 * each mounted editor registers its view here and the find bar reads from it.
 *
 * A plain Set, not React state: the find bar reads it imperatively at search
 * time and nothing needs to re-render when an editor mounts.
 */

const views = new Set();

export function registerEditorView(view) {
  if (!view) return () => {};
  views.add(view);
  return () => { views.delete(view); };
}

/**
 * Mounted AND VISIBLE views. Detached ones are dropped from the registry;
 * merely hidden ones are skipped but kept, since they can come back.
 *
 * Walter 2026-08-24: searching "test" reported 4 hits where he could see 1.
 * Opening a list full-screen leaves the board's tiles mounted behind the
 * overlay, so their editors were still being searched — and stepping into one
 * scrolled a document nobody could see. Same visibility test the textarea
 * path uses.
 */
export function getEditorViews() {
  const out = [];
  for (const v of views) {
    try {
      if (!v || !v.dom || !v.dom.isConnected) { views.delete(v); continue; }
      if (v.dom.offsetParent === null && v.dom.getClientRects().length === 0) continue;
      out.push(v);
    } catch {
      views.delete(v);
    }
  }
  return out;
}
